export enum RequestId {
    REPORT_DEFINITIONS = 'report-definitions',
    AVAILABLE_PLUGINS = 'available-plugins',
    DATA_SOURCES_PROCESSORS = 'data-sources-processors',
    DATA_SOURCES_PROVIDERS = 'data-sources-providers',
    DATA_SOURCES = "data-sources"
};
